module.exports = __webpack_public_path__ + "static/media/home-project.e17548c7.svg";